import { Button, Inline, Text } from "@softmax/design-system";
import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import type { PolicyVersionProgressCheck } from "./policy-progress-records";
import { PolicyProgressResults } from "./policy-progress-results";

const verdicts = {
  progression: "Progressed",
  regression: "Regressed",
  neutral: "Held",
} as const;

export function PolicyProgressCheck({
  check,
  onOpenCheck,
}: {
  readonly check: PolicyVersionProgressCheck;
  readonly onOpenCheck: ((id: string) => void) | undefined;
}) {
  return (
    <li {...stylex.props(styles.item)}>
      <Inline justify="between">
        {onOpenCheck ? (
          <Button
            size="sm"
            variant="quiet"
            onClick={() => onOpenCheck(check.id)}
          >
            vs {check.baselineLabel}
          </Button>
        ) : (
          <Text>vs {check.baselineLabel}</Text>
        )}
        <Inline>
          <Text size="small">
            {check.net !== null && check.verdict
              ? verdicts[check.verdict]
              : check.status.replaceAll("_", " ")}
          </Text>
          <span
            {...stylex.props(
              styles.net,
              check.net !== null &&
                check.verdict === "progression" &&
                styles.progressed,
              check.net !== null &&
                check.verdict === "regression" &&
                styles.regressed,
            )}
          >
            {check.netLabel}
          </span>
        </Inline>
      </Inline>
      <PolicyProgressResults check={check} />
    </li>
  );
}

const styles = stylex.create({
  item: {
    borderTopWidth: { default: 1, ":first-child": 0 },
    borderTopStyle: "solid",
    borderTopColor: colors.border,
    paddingBlock: spacing.space12,
    display: "grid",
    gap: spacing.space8,
  },
  net: {
    fontFamily: fonts.interface,
    fontVariantNumeric: "tabular-nums",
    fontSize: fontSizes.sectionTitle,
  },
  progressed: { color: colors.chartGreen },
  regressed: { color: colors.danger },
});
